import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
// import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { actions as appActions } from "../../../app/appSlice";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreCard from "../../../app/core/components/CoreCard/CoreCard";
import {
  useAddRateStudioMutation,
  useGetStudioDetailQuery,
  useUnlinkStudioMutation,
} from "../../api/user/associaStudioApi";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const MioStudioPage = () => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [isValidCode, setIsValidCode] = useState(true);

  const dispatch = useDispatch();
  const studioId = useSelector((state) => state.app.studioId);
  const navigate = useNavigate();

  const appConfig = useSelector((state) => state.app.appConfig);

  const { data: studioDetail, isLoading: studioDetailLoading } =
    useGetStudioDetailQuery(studioId, { skip: !studioId });

  const [addRateStudio] = useAddRateStudioMutation();

  const [unlinkStudio, { isLoading: isUnlinkingStudio }] =
    useUnlinkStudioMutation();

  const handleRemove = () => {
    unlinkStudio({ studioId })
      .then(() => {
        dispatch(
          appActions.resetUser({
            primaryColor: appConfig?.assets?.colors?.primaryColor,
            secondaryColor: appConfig?.assets?.colors?.secondaryColor,
          })
        );
        toast.success(t("StudioUnassociated"));
        navigate(`/auth/user/${t("documentManagement")}`); //TOODO navigate("/auth/user/dashboard")
      })
      .catch(() => {
        toast.error("Errore nella rimozione del servizio");
      });
  };

  if (!studioId) return <>{`${t("NotAlreadyAssociated")}`}</>;

  if (studioDetailLoading) {
    return <CoreSpinner />;
  }

  return (
    <>
      <div className="flex justify-center">
        <div className="w-7/12">
          <div className="flex items-center">
            <h2 className="w-full text-center">{studioDetail?.Data?.name}</h2>
          </div>
          <div className="flex justify-center items-center ">
            {studioDetail?.Data?.logoImageUrl ? (
              <div className="flex ">
                <CoreCard
                  className="flex justify-center"
                  width={"10rem"}
                  height={"10rem"}
                  child={
                    <img
                      alt="logo"
                      src={studioDetail?.Data?.logoImageUrl}
                      className="w-full h-full"
                    />
                  }
                />
              </div>
            ) : (
              <CoreCard
                className="flex justify-center"
                width={"10rem"}
                height={"10rem"}
                child={"Nessun Logo"}
              />
            )}
          </div>
          <div className="w-full py-4">
            <h3>{t("Description")}</h3>
            <div>
              {studioDetail?.Data?.description || (
                <p className="text-gray">N/A</p>
              )}
            </div>
          </div>

          <div className="flex space-x-6 ">
            <div className="flex flex-col w-6/12">
              <h3>{t("Services")}</h3>
              {studioDetail?.Data?.services?.map((servizio, idx) => (
                <div
                  style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                  key={idx}
                >
                  {servizio.name}
                </div>
              ))}
            </div>
            <div className="flex flex-col items-end  w-6/12">
              <div>
                <h3>{t("Contacts")}</h3>
                <div className="w-full flex flex-col">
                  <CoreButtonIcon
                    disabled
                    className={"ml-2"}
                    icon={
                      <EmailRoundedIcon
                        style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                      />
                    }
                    testo={
                      studioDetail?.Data?.email
                        ? studioDetail?.Data?.email
                        : "N/A"
                    }
                  />
                  <CoreButtonIcon
                    disabled
                    className={"ml-2"}
                    icon={
                      <LocalPhoneIcon
                        style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                      />
                    }
                    testo={studioDetail?.Data?.phoneNumber || "N/A"}
                  />
                  <CoreButtonIcon
                    disabled
                    className={"ml-2"}
                    icon={
                      <LanguageIcon
                        style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                      />
                    }
                    testo={studioDetail?.Data?.website || "N/A"}
                  />
                  <CoreButtonIcon
                    disabled
                    className={"ml-2 text-neutral-900 "}
                    icon={
                      <LocationOnIcon
                        style={{ color: `${studioDetail?.Data?.primaryColor}` }}
                      />
                    }
                    testo={studioDetail?.Data?.address || "N/A"}
                  />
                </div>
              </div>
            </div>
          </div>

          {/*           
            <div className="py-10 flex justify-center">
              <CoreButton
                disabled={isUnlinkingStudio}
                testo={isUnlinkingStudio ? "attendere" : "dissocia"}
                className="btn-round"
                type="submit"
                onClick={handleRemove}
              />
            </div> */}
        </div>
      </div>
    </>
  );
};

export default MioStudioPage;
